<script lang="ts">
    import { onMount } from "svelte";
	import { get } from "svelte/store";
    import { storeActus, storeActu, Actu } from "../scripts/classes/actu";
    import { redirectTo } from "../scripts/router1";
	import { idPageActu } from "../scripts/router2";

	export let inEvent: Actu;
	let isPresential: boolean = false;
	let day: string;
	let monthLong: string;
	let monthShort: string;
	let year: string;

	onMount(async() => {
		extractDateInfos(inEvent.date);
		if (inEvent.event_type == 2) {
			isPresential = true;
		}
	})

	function extractDateInfos(inDate: string) {
		const dateArray = inDate.split("-");
		year = dateArray[0];
		day = dateArray[2];
		const date = new Date(parseInt(year), parseInt(dateArray[1]) - 1, parseInt(day));  // 2009-11-10
		monthShort = date.toLocaleString('default', { month: 'short' });
		monthLong = date.toLocaleString('default', { month: 'long' });
		day = parseInt(day).toString();
	}

	function selectActu() {
		const filteredActus = get(storeActus).filter((actu) => actu.id == inEvent.id)[0];
		if (filteredActus != undefined && filteredActus != "") {
			storeActu.set(filteredActus);
			redirectTo(idPageActu, "?id="+inEvent.id);    
		}
	}

</script>

<style lang="scss">

	.eventinsight {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		max-height: 100px;
		width: 80%;
		min-width: 200px;
		border: 1px solid black;
		border-radius: 15px;
		background-color: $color_white;
		padding: 5px 5px 5px 5px;
        margin: 10px 0px 10px 0px;
		flex-wrap: nowrap;
		overflow: hidden;
		white-space: nowrap;
		&__title {
			font-weight: bold;
			text-wrap: nowrap;
			text-overflow: ellipsis;
			align-self: flex-start;
			white-space: nowrap;
    		width: 100%;
			display: block;
			overflow: hidden;
		}
	}

    @include large {
		.eventinsight {
			width: 200px;
			cursor: pointer;
			margin: 0px 10px 10px 10px;
			&:hover {
				background-color: $color_secondary;
			}
		}
    }
</style>

<div class="eventinsight" on:click={() => selectActu()} on:keydown={() => selectActu()}>
	{#if isPresential}
	<div>Rencontre</div>
	{:else}
	<div>Web</div>
	{/if}
	<div class="eventinsight__title">{inEvent.title}</div>
	<div>{day}&nbsp;{monthShort}&nbsp;{year}</div>
</div>